/**
 * @description used to transform result from ORDERS CREATE Api of api-gateway
 * @api - /checkout/order/create/v2 .
 *
 */
import { payUPaymentRequestDTOTransformer } from './payUPaymentRequestDTOTransformer';
import { orderDataTransformer } from './orderDataTransformer';
import { upiPaymentRequestDTOTransformer } from './upiPaymentRequestDTOTransformer';
import { razorpayRequestDTOTransformer } from './razorpayRequestDTOTransformer';
import { cashFreeRequestDTOTransformer } from './cashFreeRequestDTOTransformer';
import { cashFreeSeamlessDTOTransformer } from './cashFreeSeamlessDTOTransformer';
import { itemTransformer } from './itemTransformer';


interface ResponseType {
  items:object,
  cod_delay_message:string,
  is_new_user:boolean,
  paymentStatus:string,
  paymentGateway:string,
  orderState:string,
  paytmRequestDTO:object,
  payUPaymentRequestDTO:object,
  paymentExtraParamsDTO: object,
  razorPayPaymentRequestDTO:object,
  refer_a_friend:string,
  shipping_address:object,
  upiPaymentRequestDTO:object,
  cashfreePaymentRequestDTO:object,
  cashfreeSeamlessPaymentRequestDTO:object,
  hashValue:string,
  bankcode:string,
  paymentInitiationRequestDTO:object,
  credResponseDTO: object,
  masterPaymentStatus: string,
  showFallbackModes: boolean,
}

export const createOrderTransformer = (response: ResponseType) => {
  let transformedItems = itemTransformer(response.items || []);


  return {
    codDelayMessage: response.cod_delay_message || '',
    isNewUser: response.is_new_user || -1,
    items: transformedItems,
    orderData: orderDataTransformer(response || {}),
    paymentStatus: response.paymentStatus || '',
    paymentGateway: response.paymentGateway || '',
    orderStatus: response.orderState || '',
    paytmRequestDTO: response.paytmRequestDTO || {},
    payUPaymentRequestDTO: payUPaymentRequestDTOTransformer(
        response.payUPaymentRequestDTO || {},
      ),
    paymentExtraParamsDTO: response.paymentExtraParamsDTO || {},
    razorPayPaymentRequestDTO: razorpayRequestDTOTransformer(response.razorPayPaymentRequestDTO || {}),
    referAFriend: response.refer_a_friend || {},
    shippingAddress: response.shipping_address || {},
    upiPaymentRequestDTO: upiPaymentRequestDTOTransformer(response.upiPaymentRequestDTO || {}),
    cashfreePaymentRequestDTO: cashFreeRequestDTOTransformer(response.cashfreePaymentRequestDTO || {}),
    cashfreeSeamlessPaymentRequestDTO: cashFreeSeamlessDTOTransformer(response.cashfreeSeamlessPaymentRequestDTO || {}),
    hashValue: response.hashValue || '', // added for PaymentSuccess incase of guest users
    paymentInitiationRequestDTO: response?.paymentInitiationRequestDTO,
    credResponseDTO: response?.credResponseDTO || {},
    masterPaymentStatus: response.masterPaymentStatus || '',  // used for paymentFailureFlow
    showFallbackModes: response.showFallbackModes || false,  // used for paymentFailureFlow
  };
};
